import { TextField } from '@components/text-field';
import { useScopedTranslate } from '@locale/translate';

import { useFormBuilderContext } from './context';
import { StateField } from './state';

type Props = {
  field: Extract<StateField, { description?: string }>;
};

export const DescriptionInput = ({ field }: Props) => {
  const actions = useFormBuilderContext().store.actions;
  const { t } = useScopedTranslate(locale);

  return (
    <TextField
      onChange={actions.createChangeHandler(field, 'description')}
      defaultValue={field.description}
      label={t('label')}
      maxChars={255}
    />
  );
};

const locale = {
  en: {
    label: 'Supporting text',
  },
};
